import { render, staticRenderFns } from "./brandbar.vue?vue&type=template&id=a4b2928c&scoped=true&"
import script from "./brandbar.vue?vue&type=script&lang=js&"
export * from "./brandbar.vue?vue&type=script&lang=js&"
import style0 from "./brandbar.vue?vue&type=style&index=0&id=a4b2928c&prod&lang=scss&scoped=true&"
import style1 from "./brandbar.vue?vue&type=style&index=1&id=a4b2928c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b2928c",
  null
  
)

export default component.exports